<template>
  <date-picker
    v-model="model"
    prefix-class="datetime"
    :disabled-date="disabledDateFunc"
    :disabled-time="disabledTimeFunc"
    :type="
      type == 'time' || type == 'minutes' || type == 'hours' ? 'time' : type
    "
    value-type="format"
    :format="
      type == 'datetime'
        ? 'YYYY-MM-DD HH:mm:ss'
        : type == 'time'
        ? 'HH:mm:ss'
        : type == 'minutes'
        ? 'HH:mm'
        : type == 'hours'
        ? 'HH'
        : 'YYYY-MM-DD'
    "
    :show-time-panel="showTimePanel"
    @close="showTimePanel = false"
  >
    <template v-slot:input>
      <v-text-field
        v-model="text"
        :single-line="singleLine"
        :dense="dense"
        :error-messages="errorMessages"
        :hide-details="!errorMessages && hideDetails"
        :label="label"
        :prepend-icon="
          hideIcon ? '' : type == 'time' ? 'fa-clock' : 'fa-calendar-day'
        "
        @blur="
          text =
            type == 'datetime'
              ? $datetimeUtils.formatTime(model)
              : type == 'date'
              ? $datetimeUtils.formatDate(model)
              : $datetimeUtils.formatOnlyTime(model)
        "
        :readonly="readonly"
      ></v-text-field>
    </template>
    <template v-slot:icon-calendar>
      <v-icon></v-icon>
    </template>
    <template v-slot:icon-clear>
      <v-icon>fa-times</v-icon>
    </template>
    <template v-slot:footer v-if="type == 'datetime'">
      <button
        class="mx-btn mx-btn-text"
        @click="showTimePanel = !showTimePanel"
      >
        {{
          showTimePanel
            ? $t("$datetime.select_date")
            : $t("$datetime.select_time")
        }}
      </button>
    </template>
  </date-picker>
</template>

<script>
import i18n from "@/i18n";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "./datetime.scss";

if (i18n.locale == "zhHans") require("vue2-datepicker/locale/zh-cn");

const regDate = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
const regTime = /^(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;
const regMinutes = /^(20|21|22|23|[0-1]\d):[0-5]\d$/;
const regHours = /^(20|21|22|23|[0-1]\d)$/;
const regDatetime =
  /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;

export default {
  name: "DatetimePicker",

  components: { DatePicker },

  props: {
    value: String,
    label: String,
    type: String,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    hideIcon: Boolean,
    errorMessages: Array,
    disabledBeforeNow: Boolean,
    disabledBeforeToday: Boolean,
    disabledAfterNow: Boolean,
    disabledAfterToday: Boolean,
    disabledBeforeSpecifyTime: String,
    readonly: Boolean,
  },

  data: () => ({
    showTimePanel: false,
    model: null,
    text: "",
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.model = this.value;
      },
    },
    model: {
      immediate: true, //初始赋值也调用
      handler() {
        this.text =
          this.type == "datetime"
            ? this.$datetimeUtils.formatTime(this.model)
            : this.type == "date"
            ? this.$datetimeUtils.formatDate(this.model)
            : this.$datetimeUtils.formatOnlyTime(this.model);
        this.$emit("input", this.model);
      },
    },
    text: {
      handler() {
        var regExp =
          this.type == "datetime"
            ? new RegExp(regDatetime)
            : this.type == "time"
            ? new RegExp(regTime)
            : this.type == "minutes"
            ? new RegExp(regMinutes)
            : this.type == "hours"
            ? new RegExp(regHours)
            : new RegExp(regDate);
        if (regExp.test(this.text)) {
          this.model = this.text;
        }
      },
    },
  },

  methods: {
    disabledDateFunc(date) {
      if (
        !this.disabledBeforeNow &&
        !this.disabledBeforeToday &&
        !this.disabledAfterNow &&
        !this.disabledAfterToday &&
        !this.disabledBeforeSpecifyTime
      )
        return false;
      var now = new Date();
      if (!this.disabledBeforeNow && this.disabledBeforeToday)
        now.setHours(0, 0, 0, 0);
      if (!this.disabledAfterNow && this.disabledAfterToday) {
        now = new Date(new Date().getTime() - 24 * 3600 * 1000);
        now.setHours(0, 0, 0, 0);
      }
      if (this.disabledBeforeSpecifyTime && this.disabledAfterNow) {
        var d = new Date(this.disabledBeforeSpecifyTime);
        d.setHours(0, 0, 0, 0);
        return date > now || date < d;
      } else if (this.disabledBeforeNow || this.disabledBeforeToday)
        return date < now;
      else if (this.disabledAfterNow || this.disabledAfterToday)
        return date > now;
      else return false;
    },
    disabledTimeFunc(date) {
      if (
        !this.disabledBeforeNow &&
        !this.disabledBeforeToday &&
        !this.disabledAfterNow &&
        !this.disabledAfterToday &&
        !this.disabledBeforeSpecifyTime
      )
        return false;
      var now = new Date();
      if (!this.disabledBeforeNow && this.disabledBeforeToday)
        now.setHours(0, 0, 0, 0);
      if (!this.disabledAfterNow && this.disabledAfterToday) {
        now = new Date(new Date().getTime() - 24 * 3600 * 1000);
        now.setHours(0, 0, 0, 0);
      }
      if (this.disabledBeforeSpecifyTime && this.disabledAfterNow) {
        var d = new Date(this.disabledBeforeSpecifyTime);
        return date > now || date < d;
      } else if (this.disabledBeforeNow || this.disabledBeforeToday)
        return date < now;
      else if (this.disabledAfterNow || this.disabledAfterToday)
        return date > now;
      else return false;
    },
  },
};
</script>
